(function () {
  if (window.__pwReturnsOfferV2Loaded) return;
  window.__pwReturnsOfferV2Loaded = true;

  var initialisedRoots = new WeakSet();

  function qs(root, sel) {
    return root ? root.querySelector(sel) : null;
  }

  function safeJsonParse(txt) {
    try { return JSON.parse(txt || '{}'); } catch (e) { return {}; }
  }

  function formatMoneyFromCents(cents) {
    if (cents == null) return '';
    var n = Number(cents) / 100;
    var ccy = (window.Shopify && Shopify.currency && Shopify.currency.active)
      ? Shopify.currency.active
      : 'GBP';

    try {
      return new Intl.NumberFormat(undefined, {
        style: 'currency',
        currency: ccy
      }).format(n);
    } catch (e) {
      return '£' + n.toFixed(2);
    }
  }

  function percentOff(fullCents, gradedCents) {
    var a = Number(fullCents || 0);
    var b = Number(gradedCents || 0);
    if (!a || !b || b >= a) return '';
    return Math.round(((a - b) / a) * 100) + '%';
  }

  async function addItemsAndOpenDrawer(items) {
    if (!Array.isArray(items) || !items.length) {
      throw new Error('No cart items were supplied.');
    }

    if (
      window.PunchCart &&
      typeof window.PunchCart.addItems === 'function'
    ) {
      return window.PunchCart.addItems(items);
    }

    throw new Error(
      'The cart drawer is not ready. Please refresh the page and try again.'
    );
  }

  function init(root) {
    if (!root || initialisedRoots.has(root)) return;

    var form = qs(root, 'form.pw-product-form');
    var modal = qs(root, '[data-pw-returns-modal]');
    var cfgEl = qs(root, '[data-pw-returns-config]');
    var skuMapEl = qs(root, '[data-pw-variant-sku-map]');
    var btnNew = qs(root, '[data-pw-returns-new]');
    var btnGraded = qs(root, '[data-pw-returns-graded]');

    if (!form || !modal || !cfgEl || !skuMapEl || !btnNew || !btnGraded) {
      return;
    }

    initialisedRoots.add(root);

    var cfg = safeJsonParse(cfgEl.textContent);
    var skuMap = safeJsonParse(skuMapEl.textContent);

    var gradeAHandle = cfg.gradeAHandle || '';
    var gradeBHandle = cfg.gradeBHandle || '';
    var currentHandle = cfg.currentHandle || '';
    var offersWrap = qs(root, '[data-pw-offers-wrap]');

    var offersCache = [];
    var busy = false;
    var currentProductPromise = null;
    var gradedProductPromises = {};

    function openModal() {
      modal.hidden = false;
      document.documentElement.style.overflow = 'hidden';
    }

    function closeModal() {
      modal.hidden = true;
      document.documentElement.style.overflow = '';
    }

    function setBusy(state) {
      busy = !!state;
      [btnNew, btnGraded].forEach(function (btn) {
        if (!btn) return;
        btn.disabled = !!state;
        if (state) btn.setAttribute('aria-busy', 'true');
        else btn.removeAttribute('aria-busy');
      });
    }

    function getSelectedVariantId() {
      // 1) The visible fallback selector is the most reliable source here.
      var select = qs(root, '.pw-variant-select');
      if (select && select.value) return String(select.value);

      // 2) Support themes/apps that render variant radios.
      var checked = qs(form, 'input[name="id"]:checked');
      if (checked && checked.value) return String(checked.value);

      // 3) Final fallback: the product form's hidden Shopify variant input.
      var input = qs(form, 'input[name="id"]');
      return input ? String(input.value || '') : '';
    }

    function getSelectedSku() {
      var id = getSelectedVariantId();
      var sku = id ? (skuMap[id] || '') : '';
      return String(sku || '').trim();
    }

    function wantsCase() {
      var choice = qs(form, 'input[name="pw_set_choice"]:checked');
      return !!choice && choice.value === 'case' && !choice.disabled;
    }

    function getCaseVariantId() {
      if (!wantsCase()) return '';
      return String(form.getAttribute('data-case-variant-id') || '').trim();
    }

    function buildNewItems() {
      var selectedId = getSelectedVariantId();
      if (!selectedId) throw new Error('Please choose an available variant.');

      var items = [{ id: Number(selectedId), quantity: 1 }];
      var caseId = getCaseVariantId();

      if (caseId) {
        items.push({ id: Number(caseId), quantity: 1 });
      }

      return items;
    }

    function buildGradedItems(offer) {
      if (!offer || !offer.variantId) {
        throw new Error('That graded return is no longer available.');
      }

      var items = [{ id: Number(offer.variantId), quantity: 1 }];
      var caseId = getCaseVariantId();

      if (caseId) {
        items.push({ id: Number(caseId), quantity: 1 });
      }

      return items;
    }

    async function fetchProductJson(handle) {
      if (!handle) return null;

      if (!gradedProductPromises[handle]) {
        gradedProductPromises[handle] = fetch('/products/' + handle + '.js', {
          headers: { Accept: 'application/json' },
          cache: 'no-store'
        }).then(function (res) {
          if (!res.ok) return null;
          return res.json();
        }).catch(function () {
          return null;
        });
      }

      return gradedProductPromises[handle];
    }

    function findAvailableVariantBySku(productJson, sku) {
      if (!productJson || !Array.isArray(productJson.variants) || !sku) return null;

      return productJson.variants.find(function (v) {
        return String(v.sku || '').trim() === sku && v.available === true;
      }) || null;
    }

    function getCurrentProductJson() {
      if (!currentHandle) return Promise.resolve(null);
      if (!currentProductPromise) {
        currentProductPromise = fetch('/products/' + currentHandle + '.js', {
          headers: { Accept: 'application/json' },
          cache: 'no-store'
        }).then(function (res) {
          if (!res.ok) return null;
          return res.json();
        }).catch(function () {
          return null;
        });
      }
      return currentProductPromise;
    }

    async function getFullPriceCents() {
      var selectedId = Number(getSelectedVariantId());
      var currentJson = await getCurrentProductJson();
      if (!currentJson || !Array.isArray(currentJson.variants)) return 0;

      var variant = currentJson.variants.find(function (v) {
        return Number(v.id) === selectedId;
      }) || null;

      return variant ? Number(variant.price || 0) : 0;
    }

    async function checkOfferAll() {
      var baseSku = getSelectedSku();
      if (!baseSku) return [];

      var skuA = baseSku + '-RA';
      var skuB = baseSku + '-RB';

      var results = await Promise.all([
        gradeAHandle ? fetchProductJson(gradeAHandle) : Promise.resolve(null),
        gradeBHandle ? fetchProductJson(gradeBHandle) : Promise.resolve(null)
      ]);

      var vA = results[0] ? findAvailableVariantBySku(results[0], skuA) : null;
      var vB = results[1] ? findAvailableVariantBySku(results[1], skuB) : null;
      var offers = [];

      if (vA) {
        offers.push({
          grade: 'A',
          label: 'Light',
          variantId: vA.id,
          qty: (typeof vA.inventory_quantity === 'number') ? vA.inventory_quantity : 1,
          price: Number(vA.price || 0),
          compare_at: Number(vA.compare_at_price || 0)
        });
      }

      if (vB) {
        offers.push({
          grade: 'B',
          label: 'Moderate',
          variantId: vB.id,
          qty: (typeof vB.inventory_quantity === 'number') ? vB.inventory_quantity : 1,
          price: Number(vB.price || 0),
          compare_at: Number(vB.compare_at_price || 0)
        });
      }

      return offers;
    }

    async function addOffer(offer, button) {
      if (busy) return;
      setBusy(true);
      if (button) button.disabled = true;

      try {
        closeModal();
        await addItemsAndOpenDrawer(buildGradedItems(offer));
      } catch (err) {
        console.error('[PW returns] graded add error', err);
        openModal();
        alert(err.message || 'Sorry — could not add that item. Please try again.');
      } finally {
        setBusy(false);
        if (button) button.disabled = false;
      }
    }

    function setOfferCard(grade, offer, fullPriceCents) {
      if (!offersWrap) return;

      var card = offersWrap.querySelector('[data-pw-offer-card="' + grade + '"]');
      if (!card) return;

      if (!offer) {
        card.hidden = true;
        return;
      }

      card.hidden = false;

      var stockEl = offersWrap.querySelector('[data-pw-offer-stock="' + grade + '"]');
      var compareEl = offersWrap.querySelector('[data-pw-offer-compare="' + grade + '"]');
      var gradedEl = offersWrap.querySelector('[data-pw-offer-graded="' + grade + '"]');
      var saveEl = offersWrap.querySelector('[data-pw-offer-save="' + grade + '"]');
      var addBtn = offersWrap.querySelector('[data-pw-offer-add="' + grade + '"]');

      if (stockEl) stockEl.textContent = 'Only ' + Math.max(1, Number(offer.qty || 1)) + ' available';

      var compareCents = (
        offer.compare_at && offer.compare_at > offer.price
      ) ? offer.compare_at : fullPriceCents;

      if (compareEl) compareEl.textContent = compareCents ? formatMoneyFromCents(compareCents) : '';
      if (gradedEl) gradedEl.textContent = offer.price ? formatMoneyFromCents(offer.price) : '';

      if (saveEl) {
        var pct = percentOff(compareCents, offer.price);
        saveEl.textContent = pct ? ('Save ' + pct) : '';
      }

      if (addBtn) {
        addBtn.onclick = function () {
          addOffer(offer, addBtn);
        };
      }
    }

    function setOffersLayout(count) {
      if (!offersWrap) return;
      offersWrap.classList.toggle('pw-two-col', count >= 2);
    }

    function bestOffer(offers) {
      var a = (offers || []).find(function (o) { return o.grade === 'A'; });
      if (a) return a;
      return (offers || []).find(function (o) { return o.grade === 'B'; }) || null;
    }

    root.addEventListener('click', function (e) {
      if (e.target.closest('[data-pw-returns-close]')) {
        closeModal();
      }
    });

    // This is the sole owner of the main PUNCH product form.
    // It always uses AJAX, so this form never falls through to /cart.
    form.addEventListener('submit', async function (e) {
      e.preventDefault();
      e.stopPropagation();

      if (busy) return;
      setBusy(true);

      try {
        var offers = [];

        if (gradeAHandle || gradeBHandle) {
          offers = await checkOfferAll();
        }

        offersCache = offers || [];

        if (!offersCache.length) {
          await addItemsAndOpenDrawer(buildNewItems());
          return;
        }

        var fullPriceCents = await getFullPriceCents();
        var byA = offersCache.find(function (o) { return o.grade === 'A'; }) || null;
        var byB = offersCache.find(function (o) { return o.grade === 'B'; }) || null;

        setOfferCard('A', byA, fullPriceCents);
        setOfferCard('B', byB, fullPriceCents);
        setOffersLayout((byA ? 1 : 0) + (byB ? 1 : 0));

        openModal();
      } catch (err) {
        console.error('[PW returns] submit error', err);
        alert(err.message || 'Sorry — could not add that item. Please try again.');
      } finally {
        setBusy(false);
      }
    }, true);

    // Continue with new: add the selected NEW sunglasses variant and optional case.
    // No sessionStorage dismissal and no native form.submit().
    btnNew.addEventListener('click', async function () {
      if (busy) return;
      setBusy(true);

      try {
        closeModal();
        await addItemsAndOpenDrawer(buildNewItems());
      } catch (err) {
        console.error('[PW returns] new add error', err);
        openModal();
        alert(err.message || 'Sorry — could not add that item. Please try again.');
      } finally {
        setBusy(false);
      }
    });

    // Add graded and save: Grade A first when available, otherwise Grade B.
    btnGraded.addEventListener('click', async function () {
      var offer = bestOffer(offersCache);
      if (!offer) return;
      await addOffer(offer, btnGraded);
    });
  }

  function boot() {
    document.querySelectorAll('.pw-prod-mock').forEach(init);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }

  document.addEventListener('shopify:section:load', boot);
})();
